import { render, staticRenderFns } from "./DatasetPropertiesInformation.vue?vue&type=template&id=0aafcdd3&scoped=true&"
import script from "./DatasetPropertiesInformation.vue?vue&type=script&lang=js&"
export * from "./DatasetPropertiesInformation.vue?vue&type=script&lang=js&"
import style0 from "./DatasetPropertiesInformation.vue?vue&type=style&index=0&id=0aafcdd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aafcdd3",
  null
  
)

export default component.exports